import { useEffect } from "react";

export default function Tob() {
  useEffect(() => {
    window.location.href = "https://forms.gle/MWb8uJsYD6yTFHxw7";
  }, []);

  return <></>;
}
